import Axios from 'axios';
import axiosInstance from '../axios/axiosInstance';

export const getFeatureItems = () =>
	axiosInstance.get('auction/feautredauction');

export const getAuctionCategories = () =>
	Axios.get(`http://eaapi2.dev.arabiansystems.com/v2/auctions?source=mweb`);

export const getShoppingCart = () =>
	axiosInstance.get('account/getordersummary');

export const removeShoppingCartItem = (plateId, actionType) =>
	axiosInstance.get(
		`account/RemoveFromCart?AuctionType=${actionType}&PlateId=${plateId}`
	);

export const removeShoppingCartMobileItem = (mobileId, actionType) =>
	axiosInstance.get(
		`account/RemoveFromCart?AuctionType=${actionType}&mobileid=${mobileId}`
	);

export const getHomeState = () => axiosInstance.get(`common/homestats`);

export const getCurrentUserCode = () => {
	return Axios.get('https://ipapi.co/json/');
};
